import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('INR');

  useEffect(() => {
    const storedCurrency = localStorage.getItem('currentCurrency');
    if (storedCurrency) {
      setCurrency(storedCurrency);
    }
  }, []);

  const changeCurrency = (newCurrency) => {
    setCurrency(newCurrency);
    localStorage.setItem('currentCurrency', newCurrency);
    window.dispatchEvent(new Event('currencyUpdated'));
  };

  const getCurrencySymbol = () => {
    return currency === 'SGD' ? 'S$' : '₹';
  };

  const formatPrice = (priceVal, dollarPriceVal) => {
    if (currency === 'SGD') {
      const p = dollarPriceVal !== undefined && dollarPriceVal !== null && dollarPriceVal !== "" && Number(dollarPriceVal) > 0
        ? Number(dollarPriceVal)
        : Math.round(Number(priceVal || 0) / 60);
      return `S$ ${p.toLocaleString()}`;
    }
    return `₹ ${Number(priceVal || 0).toLocaleString()}`;
  };

  const formatPriceOnly = (priceVal, dollarPriceVal) => {
    if (currency === 'SGD') {
      return dollarPriceVal !== undefined && dollarPriceVal !== null && dollarPriceVal !== "" && Number(dollarPriceVal) > 0
        ? Number(dollarPriceVal)
        : Math.round(Number(priceVal || 0) / 60);
    }
    return Number(priceVal || 0);
  };

  const getProductPrice = (item, selectedRow) => {
    if (currency === 'SGD') {
      const dollarPrice = selectedRow ? selectedRow.dollarPrice : item?.dollarPrice;
      if (dollarPrice !== undefined && dollarPrice !== null && dollarPrice !== "" && Number(dollarPrice) > 0) {
        return Number(dollarPrice);
      }
      return null;
    } else {
      return Number(selectedRow ? selectedRow.price : (item?.price || item?.offerPrice || 0));
    }
  };

  const getProductMrp = (item, selectedRow) => {
    if (currency === 'SGD') {
      const price = getProductPrice(item, selectedRow);
      if (price === null) return null;
      return Math.round(price * 1.25);
    } else {
      return Number(selectedRow ? selectedRow.customermrp : (item?.mrpPrice || item?.price || item?.customermrp || 0));
    }
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency: changeCurrency, getCurrencySymbol, formatPrice, formatPriceOnly, getProductPrice, getProductMrp }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) throw new Error('useCurrency must be used within a CurrencyProvider');
  return context;
};
